import { createAction } from 'redux-actions';
import { takeLatest } from 'redux-saga/effects';
import { createRequestActionType, createPromiseSaga, reducerUtils, handleDefaultActions } from '../lib/request';
import * as eventAPI from 'api/event';

// 1.Creact Action Type
const [EVENT_DETAIL, EVENT_DETAIL_SUCCESS, EVENT_DETAIL_FAILURE] = createRequestActionType('event/EVENT_DETAIL');

// 2.Create Action
export const eventDetailAction = createAction(EVENT_DETAIL);

// 3.Create Saga function
const getEventDetail = createPromiseSaga(EVENT_DETAIL, eventAPI.getEventDetail);

export function* eventSaga() {
	yield takeLatest(EVENT_DETAIL, getEventDetail);
}

// 4.Create state
const initState = {
	event: reducerUtils.initial()
};

// 5.Create Action handling
const eventReducer = (state = initState, action) => {
	switch (action.type) {
		case EVENT_DETAIL:
		case EVENT_DETAIL_SUCCESS:
		case EVENT_DETAIL_FAILURE:
			return handleDefaultActions(EVENT_DETAIL, 'event', false)(state, action);
		default:
			return state;
	}
};

export default eventReducer;
